import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder, getEventById, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";

import logoDE from "../images/logo_de.png";
import logoFR from "../images/logo_fr.png";
import banner from "../images/banner.jpg";

import imgIconProgressGrey from "../images/progress-bar/icon-progress-grey.svg";
import imgIconProgressTick from "../images/progress-bar/icon-progress-tick.svg";
import imgIconProgress3 from "../images/progress-bar/icon-progress3.svg";

const AdditionalInformation = () => {
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        email: "",
        function: "",
        countryId: 176,
        email: "",
        confirmemail: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);
    const orderAddress = JSON.parse(sessionStorage.getItem("FassadenOrderAddress"));

    // fetching params
    const { language } = useParams();

    let languageId = 0;

    let logo = logoDE;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            logo = logoFR;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
        }
    }, [orderId]); //gets called when an order is started

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const removePromotionCode = async (promotion) => {
        try {
            const response = axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotion}`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            setOrder(updatedOrder);
            setTickets(updatedTickets);

            const address = await getAddressOfOrder(orderId);
            setBuyerInfo({ ...buyerInfo, ...address });
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onInputChange = (e, ticketId) => {

        tickets.forEach(t => {
            if (t.id === ticketId) {
                t[e.target.name] = e.target.value;
            }
        });

        setTickets([...tickets]);
    };

    const onRadioInputChange = (e, ticketId) => {
        setTickets(tickets.map(t =>
            t.id === ticketId
                ? { ...t, [e.target.name.replace(/_\d+$/, "")]: e.target.value }
                : t
        ));
    };   

    const addDataToTickets = () => {

        //update ticket address
        tickets.forEach((t, key, tickets) => {
            let ticketBody = {
                option5: t.option5,
                option4: t.option4,
                option2: t.option2,
                option3: t.option3,
                salutation: t.salutation,
                firstname: t.firstname,
                name: t.lastname,
                function: t.function,
                email: t.email,
            };

            axios
                .put(`${baseUrl}/Ticket/${t.id}/Address`, ticketBody)
                .then(() => {
                    if (Object.is(tickets.length - 1, key)) {
                        /* redirect to checkout page on last interation */
                        navigate(`/${language}/checkout`)
                    }
                })
                .catch((error) => console.log(error.response.data));
        });
    }

    // validating input fields
    let validatorTicketInputs = 0;

    tickets.forEach(t => {
        if (!(
            t.option4 && /^.{1,70}$/.test(t.option4) &&
            t.option2 && /^.{1,70}$/.test(t.option2) &&
            t.option3 && /^.{1,70}$/.test(t.option3))) {
            validatorTicketInputs += 1;
        }
    });

    const onBackClick = async () => {
        const promotioncode = sessionStorage.getItem("addedPromotion");

        if (promotioncode?.length > 0) {
            await removePromotionCode(promotioncode);
        }

        navigate(-1)
    }

    const onClickFillUserData = (ticketId) => {
        tickets.forEach(t => {

            if (t.id === ticketId) {
                t.option4 = orderAddress.option4;
                t.option2 = orderAddress.option2;
                t.option3 = orderAddress.option3;
            }
        });

        setTickets([...tickets]);
    };

    const mapTicketsUserData = () => {

        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => (
                <div key={tt.id} className="mb-5">
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <h5 className="text-uppercase">Ticket: {tt.firstname} {tt.lastname}</h5>
                        </div>
                    </div>
                    {/*<div className="row mt-2">*/}
                    {/*    <div className="col-md-12">*/}
                    {/*        <small className="button" onClick={() => onClickFillUserData(tt.id)}>*/}
                    {/*            {resources?.TicketInfoGetFromBuyer}</small>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="mt-2 mb-4 row">
                        <label className="d-block">{resources?.AdditionalInfoElectionEvent}<span className="mandatory">*</span></label>
                        <div className="col-md-6 mt-2">
                            <div className="form-check">
                                <input
                                    id={`electionEvent_1_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option4_${index}`}
                                    value={resources?.AdditionalInfoElectionEvent1Value}
                                    checked={tt.option4 === resources?.AdditionalInfoElectionEvent1Value}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                />
                                <label className="form-check-label" htmlFor={`electionEvent_1_${tt.id}`}>
                                    <b>{resources?.AdditionalInfoElectionEvent1}</b><br />
                                    {resources?.AdditionalInfoElectionEvent1Desc}
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    id={`electionEvent_2_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option4_${index}`}
                                    value={resources?.AdditionalInfoElectionEvent2Value}
                                    checked={tt.option4 === resources?.AdditionalInfoElectionEvent2Value}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                />
                                <label className="form-check-label" htmlFor={`electionEvent_2_${tt.id}`}>
                                    <b>{resources?.AdditionalInfoElectionEvent2}</b><br/>
                                    {resources?.AdditionalInfoElectionEvent2Desc}
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    id={`electionEvent_3_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option4_${index}`}
                                    value={resources?.AdditionalInfoElectionEvent3Value}
                                    checked={tt.option4 === resources?.AdditionalInfoElectionEvent3Value}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor={`electionEvent_3_${tt.id}`}>
                                    <b>{resources?.AdditionalInfoElectionEvent3}</b><br />
                                    {resources?.AdditionalInfoElectionEvent3Desc}
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    id={`electionEvent_4_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option4_${index}`}
                                    value={resources?.AdditionalInfoElectionEvent4Value}
                                    checked={tt.option4 === resources?.AdditionalInfoElectionEvent4Value}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                    disabled
                                />
                                <label className="form-check-label" htmlFor={`electionEvent_4_${tt.id}`}>
                                    <b>{resources?.AdditionalInfoElectionEvent4}</b><br />
                                    {resources?.AdditionalInfoElectionEvent4Desc}
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    id={`electionEvent_5_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option4_${index}`}
                                    value={resources?.AdditionalInfoElectionEvent5Value}
                                    checked={tt.option4 === resources?.AdditionalInfoElectionEvent5Value}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                />
                                <label className="form-check-label" htmlFor={`electionEvent_5_${tt.id}`}>
                                    <b>{resources?.AdditionalInfoElectionEvent5}</b><br />
                                    {resources?.AdditionalInfoElectionEvent5Desc}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="mt-2 mb-4 row">
                        <label className="d-block">{resources?.AdditionalInfoLanguage}<span className="mandatory">*</span></label>
                        <div className="col-md-4">
                            <select className={`form-select mt-2`} value={tt.option2} name="option2" onChange={(e) => onInputChange(e, tt.id)}>
                                <option value="">{resources?.BuyerChoose}</option>
                                <option value={resources?.AdditionalInfoLanguageGerman}>{resources?.AdditionalInfoLanguageGerman}</option>
                                <option value={resources?.AdditionalInfoLanguageFrench}>{resources?.AdditionalInfoLanguageFrench}</option>
                            </select>
                        </div>
                    </div>

                    <div className="mt-2 mb-4 row">
                        <label className="d-block">{resources?.AdditionalInfoSimultaneousTranslation}<span className="mandatory">*</span></label>
                        <div className="col-md-4 mt-2">
                            <div className="form-check">
                                <input
                                    id={`translation_yes_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option3_${index}`}
                                    value={resources?.AdditionalInfoYes}
                                    checked={tt.option3 === resources?.AdditionalInfoYes}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                />
                                <label className="form-check-label" htmlFor={`translation_yes_${tt.id}`}>{resources?.AdditionalInfoYes}</label>
                            </div>
                            <div className="form-check">
                                <input
                                    id={`translation_no_${tt.id}`}
                                    type="radio"
                                    className="form-check-input"
                                    name={`option3_${index}`}
                                    value={resources?.AdditionalInfoNo}
                                    checked={tt.option3 === resources?.AdditionalInfoNo}
                                    onChange={(e) => onRadioInputChange(e, tt.id)}
                                />
                                <label className="form-check-label" htmlFor={`translation_no_${tt.id}`}>{resources?.AdditionalInfoNo}</label>
                            </div>
                        </div>
                    </div>

                </div>
            ))
        );
    }

    return (
        <>
            <div className="row">

                {/* fixed image column */}
                <div className="col-md-5 fixed-column">
                    <img className="img-fluid w-100" src={banner} alt="banner"></img>
                </div>

                {/* scrollable content column */}
                <div className="col-md-7 pt-3 ps-4 pe-4 scrollable-column">
                    <div className="d-flex justify-content-end">
                        <a href="https://www.prosenectute.ch/de.html">
                            <img className="logo" src={logo} alt="logo" href="https://www.prosenectute.ch/de.html" />
                        </a>
                    </div>

                    <div className="row mt-2">
                        <div className="col-md-12">
                            <span className="text-title d-block">{resources?.Title}</span>
                            <span className="text-subtitle d-block">{resources?.TitleDescription}</span>
                        </div>
                    </div>

                    {/* progress bar */}
                    <div className="progress-container mt-3">
                        <div className="progress-step active">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressTick} alt="Step 1" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressTickets}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step completed">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressTick} alt=" Step 2" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressYourInformation}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgress3} alt="Step 3" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressAdditionalInformation}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressGrey} alt="Step 4" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressCheckout}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-md-12">
                            <span className="text-subtitle">{resources?.AdditionalInfoPleaseFill}</span>
                        </div>
                    </div>

                    {mapTicketsUserData()}

                    <div className="row mt-5 mb-4">
                        {/*<div className=" col-6 text-start">*/}
                        {/*    <button className="btn button-custom" onClick={onBackClick}>*/}
                        {/*        {resources?.Back}*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                        <div className="col-6 text-end">
                            <button className="btn button-custom" disabled={validatorTicketInputs > 0} onClick={addDataToTickets}>{resources.Next}</button>
                        </div>
                    </div>

                    <p className="mt-4">
                        <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                    </p>
                </div>
            </div>

        </>

    )
}

export default AdditionalInformation